var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSocialLn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3574_5655)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.34767 19.2496H0.40853V6.56147H4.34767V19.2496ZM2.37649 4.8301C1.92332 4.83201 1.47975 4.6995 1.10187 4.44933C0.723993 4.19915 0.428762 3.84255 0.253505 3.4246C0.0782471 3.00665 0.0308313 2.54611 0.117252 2.10122C0.203672 1.65632 0.420048 1.24703 0.739026 0.9251C1.058 0.603169 1.46526 0.383046 1.90931 0.292559C2.35337 0.202072 2.81428 0.245284 3.23378 0.416733C3.65328 0.588181 4.01253 0.880167 4.26612 1.25578C4.51971 1.63139 4.65625 2.07377 4.65849 2.52697C4.65936 3.13445 4.41988 3.71759 3.99233 4.1491C3.56478 4.58061 2.9839 4.82542 2.37649 4.8301ZM19.0977 19.2496H15.1586V13.0714C15.1586 11.5994 15.1296 9.71177 13.1101 9.71177C11.0616 9.71177 10.7476 11.3111 10.7476 12.9651V19.2464H6.81487V6.56147H10.593V8.29768H10.6477C11.0246 7.64978 11.5703 7.11639 12.2267 6.75445C12.883 6.3925 13.6253 6.21558 14.3743 6.24258C18.3601 6.24258 19.0929 8.86782 19.0929 12.2774V19.2496H19.0977Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3574_5655"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  fill: "white",
  transform: "translate(0.0944824 0.246399)"
})))));
export default SvgIconSocialLn;